module.exports = __webpack_public_path__ + "img/cancun-tortuga.eb1e1466.jpg";